import { Component, ElementRef, Renderer2, Input, OnInit } from '@angular/core';

import { JourneyPlannerFilterItemValueSettings } from '@ridango/core/env';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'rwidget-journey-planner-filter-slider',
    templateUrl: './journey-planner-filter-slider.component.html',
    styleUrls: ['./journey-planner-filter-slider.component.scss']
})
export class JourneyPlannerFilterSliderComponent implements OnInit {
    @Input() values: Array<JourneyPlannerFilterItemValueSettings>;
    @Input() formGroup: FormGroup;
    @Input() formItem: string;
    @Input() formItemInitValue: string | number;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {}

    ngOnInit() {
        if (this.formItemInitValue !== undefined) {
            const control = this.formGroup.get(this.formItem);
            control.patchValue(this.formItemInitValue);
        }
    }

    ngAfterViewInit() {
        this.updateSliderTicksBackgroundSize();
    }

    updateSliderTicksBackgroundSize() {
        const length = this.values.length - 1;
        const tickSize = `calc(100% / ${length} - calc(2px / ${length})) 2px`;

        const tickElement = this.el.nativeElement.querySelector('.mat-slider-ticks');
        if (tickElement) {
            this.renderer.setStyle(tickElement, 'background-size', tickSize);
        }
    }
}
